import React from 'react'
import './header.css'
import company_image from '../../assets/logo.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
  return (
    //   <section id='#'>Header</section>
    // )
    // (
    <header>

      <div className='container header_container'>
        <h2 className='text-light'>Welcome to</h2>
        <div className='evolv'>
          <img src={company_image} alt='evolv' />
        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <h3 className='text-light'>Navigating Compliance with Expertise: Building a Safer, Regulated Tomorrow</h3>
        <br></br>
        <br></br>
        <div className='text-box'>
          <p className='text-light'>Welcome to Safety Check UK Limited, your trusted partner for comprehensive solutions in compliance, plant hire, and facility management. With a commitment to excellence, our specialized divisions deliver tailored services to help businesses mitigate risks, enhance safety standards, and ensure regulatory compliance. Explore our offerings and let us support you in achieving your operational goals with peace of mind.</p>
        </div>
        {/* <HeaderSocial /> */}
        <a href='#contact' className='scroll_down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header





